import { moduleName } from '@/constants/global/module';
import { CustomRouteRecord } from '@/types/router/router';

const meta = {
  moduleName: moduleName.Analytics,
  moduleVersion: '1.0.0',
};

const analyticsRoute: Array<CustomRouteRecord> = [
  {
    path: '/analytics/rfm',
    name: 'analytics-rfm-main',
    component: () => import('@/views/modules/rfm/pages/MainPage.vue'),
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'main_menu.analytics',
      },
    ],
  },
  {
    path: '/analytics/rfm/configuration',
    name: 'analytics-rfm-configuration',
    component: () => import('@/views/modules/rfm/pages/ConfigurationPage.vue'),
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'main_menu.analytics',
        to: '/analytics/rfm',
      },
      {
        text: 'rfm_configuration',
        active: true,
      },
    ],
  },
  {
    path: '/analytics/rfm/model',
    name: 'analytics-rfm-model',
    component: () => import('@/views/modules/rfm/pages/RFMModelListPage.vue'),
    meta: {
      ...meta,
    },
    breadcrumb: [
      {
        text: 'main_menu.analytics',
        to: '/analytics/rfm',
      },
      {
        text: 'main_menu.analytics_rfm',
        active: true,
      },
    ],
  },
  {
    path: '/analytics/churnRate/main',
    name: 'churn-rate-main',
    component: () => import('@/views/modules/analytics/pages/anal-churnrate/MainPage.vue'),
    breadcrumb: [
      {
        text: 'analytics.churn_rate',
      },
    ],
  },
  {
    path: '/analytics/churnRate/insight',
    name: 'churn-rate-insight',
    component: () => import('@/views/modules/analytics/pages/anal-churnrate/InsightsAnal.vue'),
    breadcrumb: [
      {
        text: 'analytics.churn_rate',
        to: '/analytics/churnRate/main',
      },
      {
        text: 'เฉพาะกลุ่มเป้าหมาย',
        to: '/analytics/churnRate/main',
      },
      {
        text: 'ข้อมูลเชิงลึก',
        active: true,
      },
    ],
  },
  {
    path: '/analytics/churnRate/calculate',
    name: 'churn-rate-calculate',
    component: () => import('@/views/modules/analytics/pages/anal-churnrate/CalAnalPage.vue'),
    breadcrumb: [
      {
        text: 'analytics.churn_rate',
        to: '/analytics/churnRate/main',
      },
      {
        text: 'คำนวณอัตราการเลิกเป็นลูกค้า',
        active: true,
      },
    ],
  },
  {
    path: '/analytics/churnRate/calculateinside',
    name: 'churn-rate-calculate-inside',
    component: () => import('@/views/modules/analytics/pages/anal-churnrate/CalInsidePage.vue'),
    breadcrumb: [
      {
        text: 'analytics.churn_rate',
        to: '/analytics/churnRate/main',
      },
      {
        text: 'คำนวณอัตราการเลิกเป็นลูกค้า',
        active: true,
      },
    ],
  },
];

export default analyticsRoute;
